/* Mavaro — tiroir panier, compteur, rafraîchissement, compatibilité apps (Kaching, upsells…) */
(function () {
  'use strict';
  if (window.MavtCart) return;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTION = 'mvr-cart-drawer';
  const nativeFetch = window.fetch.bind(window);
  let refreshing = null;

  function drawer() { return document.getElementById('mavt-cart-drawer'); }

  function setCount(count) {
    document.querySelectorAll('[data-mavt-cart-count]').forEach((el) => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  async function refresh(open) {
    if (refreshing) return refreshing;
    const el = drawer();
    if (el) el.classList.add('is-loading');
    refreshing = (async () => {
      try {
        const res = await nativeFetch(ROOT + '?sections=' + SECTION, { headers: { 'X-Mvr': '1' } });
        const json = await res.json();
        const html = json[SECTION];
        const current = drawer();
        if (html && current) {
          const tpl = document.createElement('div');
          tpl.innerHTML = html;
          const fresh = tpl.querySelector('mavt-cart-drawer');
          if (fresh) {
            const wasOpen = current.hasAttribute('open');
            current.innerHTML = fresh.innerHTML;
            current.className = fresh.className;
            current.dataset.count = fresh.dataset.count;
            if (wasOpen) current.setAttribute('open', '');
            setCount(fresh.dataset.count);
          }
        }
      } catch (e) {
        /* en cas d'échec, on retombe sur la page panier */
        if (open) window.location.href = ROOT + 'cart';
      } finally {
        const d = drawer();
        if (d) d.classList.remove('is-loading');
        refreshing = null;
      }
      if (open) MavtCart.open();
    })();
    return refreshing;
  }

  async function change(key, quantity) {
    const el = drawer();
    if (el) el.classList.add('is-loading');
    try {
      await nativeFetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Mvr': '1' },
        body: JSON.stringify({ id: key, quantity }),
      });
    } finally {
      if (document.querySelector('[data-mavt-cart-page]') && !(drawer() && drawer().hasAttribute('open'))) {
        window.location.reload();
        return;
      }
      await refresh(false);
      document.dispatchEvent(new CustomEvent('mavt:cart:changed'));
    }
  }

  /* Kaching Cart : si l'app est active, c'est SON panier qui s'ouvre (comme sur l'ancien thème) */
  const kaching = () => (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function' ? window.kachingCartApi : null);
  async function updateCount() {
    try {
      const c = await (await nativeFetch(ROOT + 'cart.js', { headers: { 'X-Mvr': '1' } })).json();
      setCount(c.item_count);
    } catch (e) { /* rien */ }
  }
  async function openKaching(refreshFirst) {
    const api = kaching();
    if (!api) return false;
    try { if (refreshFirst && typeof api.refreshCart === 'function') await api.refreshCart(); } catch (e) { /* rien */ }
    api.openCart();
    updateCount();
    return true;
  }

  let lastFocus = null;
  const MavtCart = {
    open() {
      if (kaching()) { openKaching(false); return; }
      const el = drawer();
      if (!el) { window.location.href = ROOT + 'cart'; return; }
      lastFocus = document.activeElement;
      el.setAttribute('open', '');
      document.documentElement.classList.add('mavt-scroll-lock');
      const panel = el.querySelector('.mavt-cart-drawer__panel');
      if (panel) setTimeout(() => panel.focus(), 50);
      startTimers();
    },
    close() {
      const el = drawer();
      if (!el) return;
      el.removeAttribute('open');
      document.documentElement.classList.remove('mavt-scroll-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    },
    refresh,
    change,
  };
  window.MavtCart = MavtCart;

  /* Compte à rebours (persistant pendant la session) */
  function pad(n) { return String(n).padStart(2, '0'); }
  let timerInterval = null;
  function startTimers() {
    const timers = document.querySelectorAll('mavt-cart-timer');
    if (!timers.length) return;
    const duration = parseInt(timers[0].dataset.duration || '300', 10);
    let end = 0;
    try { end = parseInt(sessionStorage.getItem('mavt-cart-timer-end') || '0', 10); } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + duration * 1000;
      try { sessionStorage.setItem('mavt-cart-timer-end', String(end)); } catch (e) {}
    }
    const tick = () => {
      const left = Math.max(0, Math.round((end - Date.now()) / 1000));
      document.querySelectorAll('[data-mavt-timer]').forEach((s) => { s.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60); });
      if (left <= 0) clearInterval(timerInterval);
    };
    clearInterval(timerInterval);
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* Clics */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-mavt-cart-open]');
    if (opener) {
      if (kaching()) { e.preventDefault(); openKaching(false); return; }
      if (drawer()) { e.preventDefault(); MavtCart.open(); }
      return;
    }
    if (e.target.closest('[data-mavt-cart-close]')) { e.preventDefault(); MavtCart.close(); return; }
    const qty = e.target.closest('[data-mavt-qty]');
    if (qty && qty.closest('mavt-cart-drawer, .mavt-cart-page')) {
      e.preventDefault();
      change(qty.dataset.key, parseInt(qty.dataset.mavtQty, 10));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { const d = drawer(); if (d && d.hasAttribute('open')) MavtCart.close(); }
  });

  /* ---------- Ajout au panier ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-mavt-product-form]');
    if (!form) return;
    e.preventDefault();
    const submitter = e.submitter && e.submitter.matches('[data-mavt-add]') ? e.submitter : document.querySelector('[data-mavt-add][form="' + form.id + '"]');
    const section = form.closest('.mavt-product, .mavt-card') || document;
    const err = section.querySelector('[data-mavt-add-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (submitter) { submitter.classList.add('is-loading'); submitter.setAttribute('aria-disabled', 'true'); }

    try {
      const body = new FormData(form);
      const res = await window.fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Mvr': '1' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      if (submitter && submitter.dataset.skipCart === 'true') {
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
        return;
      }
      document.dispatchEvent(new CustomEvent('mavt:cart:added', { detail: { item: data } }));
    } catch (error) {
      if (err) { err.textContent = error.message; err.hidden = false; }
    } finally {
      if (submitter) { submitter.classList.remove('is-loading'); submitter.removeAttribute('aria-disabled'); }
    }
  });

  /* Ajout depuis la fiche produit Mavaro */
  document.addEventListener('mavt:cart:added', async () => {
    if (await openKaching(true)) return;
    refresh(true);
  });

  /* Compatibilité apps : tout ajout au panier fait par une app (fetch ou XHR) ouvre le tiroir */
  const isCartMutation = (url) => /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url);
  const isAdd = (url) => /\/cart\/add(\.js|\.json)?(\?|$)/.test(url);

  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const headers = (init && init.headers) || {};
    const own = headers instanceof Headers ? headers.get('X-Mvr') : headers['X-Mvr'];
    const res = await nativeFetch(input, init);
    if (!own && isCartMutation(url) && res.ok) {
      setTimeout(() => (kaching() ? updateCount() : refresh(isAdd(url))), 0);
    }
    return res;
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mvrUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this.__mvrUrl)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) (kaching() ? updateCount() : refresh(isAdd(this.__mvrUrl)));
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* Éditeur de thème : garder le tiroir à jour */
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('mavt-cart-drawer[open]')) startTimers();
  });

  if (document.readyState !== 'loading') startTimers();
  else document.addEventListener('DOMContentLoaded', startTimers);
})();
